// Irish Dance — client module descriptor. Importing this file registers the module's
// custom elements (side-effect imports below) and exports the descriptor the registry
// consumes. main.ts imports this module once; that's the only core edit a module needs.
import { html } from 'lit';
import type { ClientModule } from '../types';
import './student-tab';
import './portal-widget';
import './overview-page';

const irishDance: ClientModule = {
  id: 'irish_dance',
  featureFlag: 'module_irish_dance',
  studentTabs: [
    {
      id: 'irish-dance',
      labelKey: 'irishDance.studentTab.tabLabel',
      render: (studentId: string) =>
        html`<cadence-irish-dance-student-tab .studentId=${studentId}></cadence-irish-dance-student-tab>`,
    },
  ],
  portalWidgets: [
    {
      id: 'irish-dance-progress',
      render: () => html`<cadence-irish-dance-portal-widget></cadence-irish-dance-portal-widget>`,
    },
  ],
  navItems: [
    {
      name: 'irish-dance', path: '/admin/irish-dance', labelKey: 'irishDance.nav.overview', icon: 'award',
      requires: 'students.view', requiresFeature: 'module_irish_dance',
    },
  ],
};

export default irishDance;
